module.exports = __webpack_public_path__ + "img/inventory-update.3bc8487f.svg";